import { useRef } from "react";
import { Flex } from "antd";
import { PrinterOutlined, LeftOutlined } from "@ant-design/icons";
import Button from "@/common/elements/Button";
import { StyledDarkSectionTitle } from "@/common/styles";
import SummaryInfoGrid from "./SummaryInfoGrid";
import { SummaryWrapper, SummaryHeaderBar } from "./styles";

const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

// Read-only summary shown when Super Search's Module = Warrants and a
// result row is clicked. Built entirely from the warrant/search row (see
// WarrantSearchResponse.java) — no extra API call needed. Bail Amount and
// Clearance Date aren't shown here because the current warrant/search
// endpoint doesn't return or search on them (no bondAmount/dateProcessed
// field on WarrantSearchResponse) — only Date Issued is available.
const WarrantSummaryReport = ({ row, onBack, onClose }) => {
  const printRef = useRef();

  const name = [row?.lName, row?.fName, row?.mName]
    .filter(Boolean)
    .map(capitalize)
    .join(", ");

  const data = {
    basicInfo: {
      "Warrant Number": row?.warrantNumber,
      Name: name,
      DOB: row?.dob,
      Status: row?.status,
    },
    additionalInfo: {
      Charge: row?.charge,
      "Warrant Type": row?.warrantType,
      "Date Issued": row?.dateIssued,
      Agency: row?.agency,
      Jurisdiction: row?.jurisdiction,
    },
  };

  const handlePrint = () => {
    const reportContent = printRef.current;
    if (!reportContent) return;

    const printWindow = window.open("", "", "width=800,height=900");
    printWindow.document.write(`
      <html>
        <head>
          <title>Warrant Summary - ${row?.warrantNumber}</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; color: #000; }
            h2 { font-size: 18px; margin-bottom: 4px; }
            .ant-row { display: flex; flex-wrap: wrap; }
            .info-key { display: block; font-weight: 600; text-transform: uppercase; font-size: 11px; }
            .info-value { font-size: 13px; }
          </style>
        </head>
        <body>
          <h2>Warrant Summary — ${row?.warrantNumber}</h2>
          ${reportContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <SummaryWrapper>
      <SummaryHeaderBar justify="space-between" align="center">
        <Flex align="center" gap="small">
          <Button icon={<LeftOutlined />} onClick={onBack}>
            Back to Results
          </Button>
          <StyledDarkSectionTitle as="span">
            Warrant Summary — {row?.warrantNumber}
          </StyledDarkSectionTitle>
        </Flex>
        <Flex gap="small">
          <Button
            color="primary"
            type="primary"
            variant="solid"
            icon={<PrinterOutlined />}
            onClick={handlePrint}
          >
            Print
          </Button>
          <Button onClick={onClose}>Close</Button>
        </Flex>
      </SummaryHeaderBar>

      <div ref={printRef} className="report-content">
        <SummaryInfoGrid information={data} />
      </div>
    </SummaryWrapper>
  );
};

export default WarrantSummaryReport;
